/*
 * @Date: 2021-03-01 15:59:00
 * @LastEditors: @yangwenshan
 * @LastEditTime: 2021-03-01 16:11:34
 * @FilePath: \tmk\src\store\mutation-types.js
 */
/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-28 12:09:05
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-02-26 13:31:50
 */
export const ACCESS_TOKEN = 'Access-Token'
export const ORG = 'ORG'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const DEFAULT_COLOR = 'DEFAULT_COLOR'
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK'
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const DEFAULT_FIXED_SIDEMENU= 'DEFAULT_FIXED_SIDEMENU'
export const DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN'
export const DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE'
export const DEFAULT_SHOW_TAB_MENU = 'DEFAULT_SHOW_TAB_MENU'
export const DEFAULT_NOTICE_ID = 'DEFAULT_NOTICE_ID '

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}

export const CURRENT_STEP = 'CURRENT_STEP'

//accounts

// export const THEME = 'THEME'
export const CURRENT_CUST_INFO = 'CURRENT_CUST_INFO';
export const ESP_CUST_INFO = 'ESP_CUST_INFO';
export const ESPCI_IS_NEXT = 'ESPCI_IS_NEXT'
export const ID = 'ID'
export const OWNER = 'OWNER'
export const MOBILE = 'MOBILE'
export const ESP_SP_BUSINESS = 'ESP_SP_BUSINESS'
export const ESP_SP_TRACK_RECORD = 'ESP_SP_TRACK_RECORD'
export const ESP_SP_CALCULATE_PRICE = 'ESP_SP_CALCULATE_PRICE'
export const CONDITION = 'CONDITION'
export const TRACK_RECORD_CONDITION = 'TRACK_RECORD_CONDITION'

//handout
export const LIST = 'LIST'
export const LIST_NUM = 'LIST_NUM'
export const WHERE = 'WHERE'
export const CACHE_DATA = 'CACHE_DATA'
export const PER_NUM = 'PER_NUM'
export const CURRENT = 'CURRENT'
export const HANDOUT_SUCCESS = 'HANDOUT_SUCCESS'
export const HANDOUT_RESULT = 'HANDOUT_RESULT'

//task
export const IMPORT_TASK_ID = 'IMPORT_TASK_ID'

//call-list
export const CALL_LIST_ID = 'CALL_LIST_ID'
export const CALL_LIST_NEXT_URL = 'CALL_LIST_NEXT_URL'
export const CALL_LIST_PREV_URL = 'CALL_LIST_PREV_URL'
export const CALL_LIST_QUERY_PARAMS = 'CALL_LIST_QUERY_PARAMS'

//organization
export const NODE_ID = 'NODE_ID'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js